// routes/middleware/AdminLayout.js
import React, { useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import AuthNavbar from "../../components/common/AuthNavbar";
import FooterDashBoard from "../../components/AdminSideComponents/DashBoardFooter/FooterDashBoard";

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      <AuthNavbar setIsSidebarOpen={setIsSidebarOpen} userRole="admin" />
      <div style={{ display: "flex" }} className="mt-[10px]">
        <div className="lg:w-[15%] h-[100vh]">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </div>

        <main className="lg:w-[90%] w-[100%] h-[100vh] overflow-y-scroll">
          {children}
          <FooterDashBoard />
        </main>
      </div>
    </React.Fragment>
  );
};

export default AdminLayout;